import { createApp } from 'vue'
import App from './App.vue'
import 'element-plus/dist/index.css'
import './assets/css/flex.css'
import './assets/css/all.less'
// import './registerServiceWorker'
import pinia from './pinia/index'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import globalComponent from './components/index' //引入需要注册的全部组件
import * as api from './axios/api';
import vue3SeamlessScroll from "vue3-seamless-scroll";

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
for (const componentItme in globalComponent) {
    app.component(componentItme, globalComponent[componentItme])
}

//挂载api
app.config.globalProperties.$api = api

app.use(pinia).use(router).use(vue3SeamlessScroll).mount('#app')
